import { useContext, useEffect, useState } from 'react';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

import { SelectRegion } from './selectRegion';
import { ContextApi } from '../../context/contextApi';

import styles from './style.module.scss';
import { ChipUser } from './chipUser';
import { FormEditUser } from './formEditUser';

export function ListAllUsers() {
  const {
    listAllUsers, 
    allUsers
} = useContext(ContextApi);

    function handleListUsers() {
      listAllUsers()
    }

    useEffect(() => {
      handleListUsers()
    }, [])
    

    return (
        <div className={styles.containerDadosPrincipais}>
          <div className={styles.containerAllUsersVidro}>
            {allUsers.map(user => {
              return (
                <ChipUser 
                user={user}
                handleListUsers={handleListUsers}
                />
              )
            })}
          </div>
        </div>
    )
}